import '../styles/basic.css';
import '../styles/globals.scss';
import 'animate.css';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

function MyApp({Component, pageProps}) {
  return <Component {...pageProps} />;
}

export default MyApp;
